import { configureStore } from '@reduxjs/toolkit';
import thunk from "redux-thunk";

import { authreducer } from "../reducers/authreducer";
import { cartypesreducer } from "../reducers/cartypesreducer";
import { bookingslistreducer } from "../reducers/bookingslistreducer";
import { estimatereducer } from "../reducers/estimatereducer";
import { bookingreducer } from "../reducers/bookingreducer";
import { cancelreasonreducer } from "../reducers/cancelreasonreducer";
import { promoreducer } from "../reducers/promoreducer";
import { usersreducer } from "../reducers/usersreducer";
import { notificationreducer } from "../reducers/notificationreducer";
import { driverearningreducer } from '../reducers/driverearningreducer';
import { earningreportsreducer } from '../reducers/earningreportsreducer';
import { settingsreducer } from '../reducers/settingsreducer';
import { paymentreducer } from '../reducers/paymentreducer';
import { tripreducer } from '../reducers/tripreducer';
import { tasklistreducer } from '../reducers/tasklistreducer';
import { locationreducer } from '../reducers/locationreducer';
import { chatreducer } from '../reducers/chatreducer';
import { withdrawreducer } from '../reducers/withdrawreducer';
import { gpsreducer } from '../reducers/gpsreducer';
import { languagereducer } from '../reducers/languagereducer';
import { carlistreducer } from '../reducers/carlistreducer';
import { categorylistreducer } from '../reducers/categoryreducer';
import { wallethistoryreducer } from '../reducers/wallethistoryreducer';
import { addresslistreducer } from '../reducers/addressreducer';
import { zonelistreducer } from '../reducers/zonelistreducer';
import { complainreducer } from '../reducers/complainreducer';
import { countrylistreducer } from '../reducers/countrylistreducer';
import { addmoneyreducer } from '../reducers/addmonyereducer';
import { smtpreducer } from '../reducers/smtpreducer';
import { subscriptionreducer } from '../reducers/subscriptionreducer';
import { documentFieldsReducer } from '../reducers/documentfieldsreducer';
import { documentUsersReducer } from '../reducers/documentusersreducer';
import { bankFieldReducer } from '../reducers/bankfieldreducer';
import { bankUserReducer } from '../reducers/bankuserreducer';
import adminQueueReducer from '../reducers/adminQueueReducer';
import { supportrequestreducer } from '../reducers/supportrequestreducer';
import { supportcategoryreducer } from '../reducers/supportcategoryreducer';
import adminQueueAddonReducer from '../reducers/adminQueueAddonReducer';
import { addonsreducer } from '../reducers/addonsreducer';

const rootReducer = {
  auth: authreducer,
  cartypes: cartypesreducer,
  bookinglistdata: bookingslistreducer,
  estimatedata: estimatereducer,
  bookingdata: bookingreducer,
  cancelreasondata: cancelreasonreducer,
  promodata: promoreducer,
  usersdata: usersreducer,
  notificationdata: notificationreducer,
  driverearningdata: driverearningreducer,
  earningreportsdata: earningreportsreducer,
  settingsdata: settingsreducer,
  paymentmethods: paymentreducer,
  tripdata: tripreducer,
  taskdata: tasklistreducer,
  locationdata: locationreducer,
  chatdata: chatreducer,
  withdrawdata: withdrawreducer,
  gpsdata: gpsreducer,
  languagedata: languagereducer,
  carlistdata: carlistreducer,
  categorylistdata: categorylistreducer,
  wallethistorydata: wallethistoryreducer,
  addressdata: addresslistreducer,
  zonelistdata: zonelistreducer,
  complaindata: complainreducer,
  countrylistdata: countrylistreducer,
  addmoneydata: addmoneyreducer,
  smtpdata: smtpreducer,
  subscriptiondata: subscriptionreducer,
  documentFieldsData: documentFieldsReducer,
  documentUsersData: documentUsersReducer,
  bankFieldData: bankFieldReducer,
  bankUserData: bankUserReducer,
  adminQueueData: adminQueueReducer,
  supportrequestdata: supportrequestreducer,
  supportcategorydata: supportcategoryreducer,
  adminQueueAddonData: adminQueueAddonReducer,
  addonsdata: addonsreducer,
};

export default configureStore({
  middleware: [thunk],
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production', // Disable DevTools in production
  preloadedState: undefined, // No preloaded state for better performance
  enhancers: []
});
